const pincodeCityStateUpdate = () => {
    $(document).on('blur', '.zipcode', function (e) {
        e.preventDefault();
        var pincode = $(this).val();
        var parentForm = $(this).parents('form');
        
        // Check if the input has 6 characters
        if (pincode.length === 6) {
            var mappingUrl = $('.mappingUrl').val(); // Read the backend API URL
            
            // Perform AJAX call to fetch city and state data
            $.ajax({
                url: mappingUrl, // Use the URL from the input field
                method: 'GET',
                data: { pincode: pincode }, // Add pincode as query parameter
                dataType: 'json',
                success: function(response) {
                    if (response.success) { 
                        // Assuming your response JSON contains city and state data
                        var city = response.data.city;
                        var state = response.data.state;
                        var fullStateName = response.data.stateFullName;
                       
                        // Fill city and state fields
                        parentForm.find('.city').focus();
                        parentForm.find('.city').val(city).attr('readonly', 'true');
                        parentForm.find('.state').focus();
                        parentForm.find('.state').val(state).attr('readonly', 'true');
                        $('.stateFullName').val(fullStateName);
                        parentForm.find('.countrySelector').find('.selected-state').empty().text( parentForm.find('.stateSelector').find('.item[rel="' + state + '"]').text() );
                        parentForm.find('.stateSelect option[value="' + state + '"]').prop('selected', true);
                       
                    } else {
                        parentForm.find('.countrySelector').find('.selected-state').empty().text( parentForm.find('.stateSelector').find('.item:first-child').text() );
                        parentForm.find('#stateSelect option:first-child').prop('selected', true);
                        parentForm.find('.city').val('');
                    }
                }
            });
        }
    });
}
function calculateDeliveryDate(currentDate,numberOfDays) {
  const futureDate = new Date(currentDate);
  futureDate.setDate(currentDate.getDate() + numberOfDays);

  const day = String(futureDate.getDate()).padStart(2, '0');
  const monthIndex = futureDate.getMonth();
  const year = futureDate.getFullYear();

  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  const monthName = monthNames[monthIndex];

  return `${day}-${monthName}-${year}`;
}

const estimatedDeliveryDate = () => {
    $(document).ready(function() {
        $('.check-pincode-js').click(function() {
          const pincode = $('#pincode').val();
          const deliveryUrl = $('.deliveryDateURL').val();
          // Make an AJAX request to check the pincode
          $.ajax({
            type: 'GET',
            url: deliveryUrl, // Replace with your API endpoint
            data: { pincode: pincode},
            success: function(response) {
                window.dataLayer.push({
                    event: "Delivery_Check",
                    click_text: pincode,
                    currentPage: window.location.href,
                    nextPage: deliveryUrl,
                    userID: $('input.deliveryCheck-CustomerNo').val()?$('input.deliveryCheck-CustomerNo').val(): ''
                    }
                );
              if (response.success) {
                $('.pincodeInfo').addClass('d-none');
                $('.pincodeSuccess').removeClass('d-none');
                $('.pincodeSuccess .deliveryDate').text(response.data.days);
              } else {
                var pinCodeValue = response.queryString.split("=").pop();
                if(pinCodeValue.length < 6) {
                  $('.pincodeInfo').addClass('d-none');
                  $('.pincodeInvalid').removeClass('d-none');
                } else {
                  $('.pincodeInfo').addClass('d-none');
                  $('.pincodeUndeliverable').removeClass('d-none');
                }
              }
            },
            error: function() {
              $('#result').html('An error occurred while checking the pincode.');
            }
          });
        });
    });
}

$(() => {
    pincodeCityStateUpdate();
    estimatedDeliveryDate();
});

module.exports = {pincodeCityStateUpdate,
    estimatedDeliveryDate}